import Vue from 'vue'
import App from './App.vue'
//import './registerServiceWorker'
import router from './router'
import store from './store'

import MainFooter from "./components/MainFooter";
import DefaultLayout from "./layouts/DefaultLayout";
import TestLayout from "./layouts/TestLayout";
import DefaultLayoutWithVuetify from "./layouts/DefaultLayoutWithVuetify";
import MainPageLayout from "./layouts/MainPageLayout";
import ControlPanel from "./layouts/ControlPanel";

import OrderLink from "./components/OrderLink";
import vuetify from './plugins/vuetify';
import '@babel/polyfill'
import 'roboto-fontface/css/roboto/roboto-fontface.css'
import '@mdi/font/css/materialdesignicons.css'

import 'froala-editor/js/plugins.pkgd.min.js';
import 'froala-editor/js/third_party/embedly.min';
import 'froala-editor/js/third_party/font_awesome.min';
import 'froala-editor/js/third_party/spell_checker.min';
 import 'froala-editor/css/froala_editor.pkgd.min.css';
import VueFroala from 'vue-froala-wysiwyg'
Vue.use(VueFroala)





Vue.component('main-footer', MainFooter)

Vue.component("default-layout", DefaultLayout)

Vue.component("default-layout-with-vuetify", DefaultLayoutWithVuetify)
Vue.component("main-page-layout", MainPageLayout)
Vue.component("cp-layout", ControlPanel)

Vue.component('order-link', OrderLink)

Vue.config.productionTip = false

new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount('#app')
